import type {
	FieldType,
	ICollection,
	IJobSummary,
	ISchedule,
	IScrBaseline,
	ISubJob,
	ISubJobSchedule,
	ITeamMembers
} from '@/interfaces'
import { Collection, JobSummary, Schedule, ScrBaseline, SubJobSchedule, TeamMembers } from '@/models'

export class SubJob implements ISubJob {
	[key: string]: FieldType
	id: number
	jobId: number
	subjobNumber: string
	name: string
	createBy: string | number
	createDate: Date
	startDate: Date
	productionKickoffDate: Date | null
	shipDate: Date | null
	dueDate: Date
	status: string
	contractingState: string
	productionState: string
	contractingStateAlias: string
	productionStateAlias: string
	notes: string
	newNotes: string
	buildLocation: string
	salesTeam: number
	booth: string
	timeline: string
	estimatedContractValue: number
	weightedHoursOverride: boolean
	subjobType: string | number
	schedule: ICollection<ISchedule>
	actualWorkOrderIssue: string
	actualQuoteSignOff: string
	customerRef: string
	probabilityOfSales: string
	teamResources: string[]
	teamMembers: ICollection<ITeamMembers>
	scrBaseline?: IScrBaseline
	summary: IJobSummary
	am1: number
	am2: number
	pm1: number
	pm2: number
	artist1: number
	artist2: number
	designer1: number
	designer2: number
	detailer1: number
	detailer2: number
	estimator1: number
	estimator2: number
	idSupervisor1: number
	idSupervisor2: number
	leadBuilder1: number
	leadBuilder2: number
	other1: number
	other2: number
	salesLocation: string
	targetSchedule: ISubJobSchedule | null
	baselineSchedule: ISubJobSchedule | null
	laborCalc: string | null

	constructor({
		id,
		jobId,
		subjobNumber,
		name,
		createBy,
		createDate,
		startDate,
		productionKickoffDate,
		shipDate,
		dueDate,
		status,
		contractingState,
		productionState,
		contractingStateAlias,
		productionStateAlias,
		notes,
		newNotes,
		buildLocation,
		salesTeam,
		booth,
		timeline,
		estimatedContractValue,
		weightedHoursOverride,
		subjobType,
		schedule,
		actualWorkOrderIssue,
		actualQuoteSignOff,
		customerRef,
		probabilityOfSales,
		teamResources,
		teamMembers,
		scrBaseline,
		summary,
		am1,
		am2,
		pm1,
		pm2,
		artist1,
		artist2,
		designer1,
		designer2,
		detailer1,
		detailer2,
		estimator1,
		estimator2,
		idSupervisor1,
		idSupervisor2,
		leadBuilder1,
		leadBuilder2,
		other1,
		other2,
		salesLocation,
		targetSchedule,
		baselineSchedule,
		laborCalc
	}: ISubJob) {
		this.id = id
		this.jobId = jobId
		this.subjobNumber = subjobNumber
		this.name = name
		this.createBy = createBy
		this.createDate = createDate || new Date()
		this.startDate = startDate
		this.productionKickoffDate = productionKickoffDate || null
		this.shipDate = shipDate || null
		this.dueDate = dueDate
		this.status = status
		this.contractingState = contractingState || ''
		this.productionState = productionState || ''
		this.contractingStateAlias = contractingStateAlias || ''
		this.productionStateAlias = productionStateAlias || ''
		this.notes = notes || ''
		this.newNotes = newNotes || ''
		this.buildLocation = buildLocation || '0'
		this.salesTeam = salesTeam
		this.booth = booth
		this.timeline = timeline || '0'
		this.estimatedContractValue = estimatedContractValue || 0
		this.weightedHoursOverride = weightedHoursOverride || false
		this.subjobType = subjobType || 0
		this.schedule = new Collection(Schedule, schedule)
		this.actualWorkOrderIssue = actualWorkOrderIssue
		this.actualQuoteSignOff = actualQuoteSignOff
		this.customerRef = customerRef || ''
		this.probabilityOfSales = probabilityOfSales || ''
		this.teamResources = teamResources
		this.teamMembers = new Collection(TeamMembers, teamMembers)
		this.scrBaseline = scrBaseline ? new ScrBaseline(scrBaseline) : undefined
		this.summary = new JobSummary(summary)
		this.am1 = am1 || 0
		this.am2 = am2 || 0
		this.pm1 = pm1 || 0
		this.pm2 = pm2 || 0
		this.artist1 = artist1 || 0
		this.artist2 = artist2 || 0
		this.designer1 = designer1 || 0
		this.designer2 = designer2 || 0
		this.detailer1 = detailer1 || 0
		this.detailer2 = detailer2 || 0
		this.estimator1 = estimator1 || 0
		this.estimator2 = estimator2 || 0
		this.idSupervisor1 = idSupervisor1 || 0
		this.idSupervisor2 = idSupervisor2 || 0
		this.leadBuilder1 = leadBuilder1 || 0
		this.leadBuilder2 = leadBuilder2 || 0
		this.other1 = other1 || 0
		this.other2 = other2 || 0
		this.salesLocation = salesLocation
		this.targetSchedule = targetSchedule ? new SubJobSchedule(targetSchedule) : null
		this.baselineSchedule = baselineSchedule ? new SubJobSchedule(baselineSchedule) : null
		this.laborCalc = laborCalc ?? null
	}
}
